module.exports = __webpack_public_path__ + "img/chat-score.ed145065.png";